import { render, staticRenderFns } from "./resource-item.vue?vue&type=template&id=1a3d9e66&scoped=true"
import script from "./resource-item.vue?vue&type=script&lang=js"
export * from "./resource-item.vue?vue&type=script&lang=js"
import style0 from "./resource-item.vue?vue&type=style&index=0&id=1a3d9e66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3d9e66",
  null
  
)

export default component.exports